/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _5 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>5 - Библиотеки компонентов</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://material-ui.com/" target="_blank" rel="noopener noreferrer">
          MATERIAL-UI
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://ant.design/" target="_blank" rel="noopener noreferrer">
          Ant Design
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://react-bootstrap.github.io/" target="_blank" rel="noopener noreferrer">
          React Bootstrap
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://react.semantic-ui.com/" target="_blank" rel="noopener noreferrer">
          Semantic UI React
        </a>
      </li>
    </ul>
  </section>
))
